/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const questionDataAttributeSchema = z.enum(['name', 'email', 'phone', 'contact_consent', 'cv'])

export type QuestionDataAttributeSchema = z.infer<typeof questionDataAttributeSchema>
